import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';

import PageHeader from '../../components/page-header/page-header.component';
import { scrollTop } from '../../utils/utils';
import { deliveryInfos } from './text-delivery-infos';
import './delivery-infos.styles.scss';

const DeliveryInfos = () => {
  const { overline, title, lead, blocks } = deliveryInfos;

  return (
    <div className="delivery-infos-page">
      <PageHeader overline={overline} title={title} lead={lead} />

      <div className="delivery-infos-grid">
        {blocks.map((block) => (
          <article className="delivery-infos-block" key={block.title}>
            <h2 className="delivery-infos-block-title">{block.title}</h2>
            <p className="delivery-infos-block-text">{block.text}</p>
          </article>
        ))}
      </div>

      <Link
        className="brand-link delivery-infos-cta"
        to="/shop"
        onClick={scrollTop}
      >
        Voir la boutique
        <span className="brand-link-arrow" aria-hidden="true">
          <BsArrowRight />
        </span>
      </Link>
    </div>
  );
};

export default DeliveryInfos;
